export const getFileNameFromUrl = (url: string): string | undefined => {
  if (!url) {
    return undefined
  }

  const urlWithoutParams = url.split('?')[0].split('#')[0]

  const fileName = urlWithoutParams.split('/').pop()

  if (!fileName) {
    return undefined
  }

  return decodeURIComponent(fileName)
}

export const downloadFileFromUrl = async (fileUrl: string, fileName?: string): Promise<void> => {
  const response = await fetch(fileUrl)

  if (!response.ok) {
    throw new Error(`Download request failed with status ${response.status}`)
  }

  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  const downloadFileName = fileName || getFileNameFromUrl(fileUrl)

  if (downloadFileName) {
    link.setAttribute('download', downloadFileName)
  }

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

// Revoking right after `click()` can cancel the download in some browsers before it has read
// the blob, so the URL is kept alive briefly.
const OBJECT_URL_REVOKE_DELAY_MS = 1000

/**
 * Saves an in-memory file (e.g. a PDF fetched behind the bearer token) under `fileName`. The
 * object URL is revoked after a short delay, once the browser has started the download.
 */
export const saveBlobAsFile = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.setTimeout(() => {
    window.URL.revokeObjectURL(url)
  }, OBJECT_URL_REVOKE_DELAY_MS)
}
